import { observable } from 'mobx';
import { fetchCardList, setSalaryAccount, refreshSalaryAccount } from '@/services/banks';

// 银行卡配置信息
const banks = observable({
  // 银行卡列表
  cardList: [],
  //设置结果
  result: false,
  // 获取银行卡信息
  async getCardInfo(params) {
    const { item } = await fetchCardList(params);
    this.cardList = item;
  },
  // 更新结算卡信息
  async refreshSalaryAccount(payload) {
    return await refreshSalaryAccount(payload);
  },
  // 清空银行卡信息
  clearCardInfo() {
    this.cardList = [];
  },
  // 设置结算卡
  async setAccount(payload) {
    const header = payload.header || {};
    delete payload.header;
    await setSalaryAccount(payload, header);
    this.result = true;
  },
});

export default banks;
